import { Link, Tooltip } from '@mui/material';

const CollapsePlain = ({ length, tooltip }) => {
    return (
        <Tooltip title={tooltip}>
            <Link underline="none" sx={{ cursor: 'pointer' }}>
                &nbsp;+{length - 1}
            </Link>
        </Tooltip>
    );
};

export default CollapsePlain;
